import type { ReactNode } from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/system';

import { UserAvatar } from 'Common/UserAvatar';
import { getUserDisplayName } from 'Utils/user';

const Container = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledTypography = styled(Typography)`
  margin-left: 8px;
  white-space: nowrap;
  font-size: clamp(12px, 1vw, 14px);
  overflow: hidden;
  text-overflow: ellipsis;
`;

type Props = {
  name: string | null | undefined;
  avatarColor: string;
  avatar: string | null | undefined;
  customAvatar?: ReactNode;
};

export const UserInfo = ({ name, avatarColor, avatar, customAvatar }: Readonly<Props>) => {
  const userName = getUserDisplayName(name);

  return (
    <Container>
      {customAvatar ?? (
        <UserAvatar
          displayName={userName}
          color={avatarColor}
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          avatarUrl={avatar || undefined}
        />
      )}
      <StyledTypography>{userName}</StyledTypography>
    </Container>
  );
};
